import api from '@/services/api';
import { TNewPayment } from '@/services/payments';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const usePostPayments = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationKey: ['postPayments'],
    mutationFn: (data: TNewPayment) => {
      return api.payments.postPayment(data);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === 'sale' || query.queryKey[0] === 'sales'
      });
      toast.success(t('toast.paymentCreatedSuccess'));
    },
    retry: false
  });
};

export default usePostPayments;
